var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgWifiLine = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.690002 6.997C3.88909 4.40532 7.88285 2.99391 12 3C16.285 3 20.22 4.497 23.31 6.997L22.054 8.553C19.2102 6.24908 15.6599 4.99444 12 5C8.191 5 4.694 6.33 1.946 8.553L0.690002 6.997ZM3.831 10.887C6.1416 9.015 9.02624 7.99554 12 8C15.094 8 17.936 9.081 20.169 10.886L18.912 12.442C16.9568 10.8583 14.5161 9.99602 12 10C9.382 10 6.977 10.915 5.088 12.442L3.831 10.886V10.887ZM6.973 14.777C8.39485 13.6249 10.17 12.9974 12 13C13.904 13 15.653 13.665 17.027 14.776L15.77 16.332C14.7036 15.4682 13.3723 14.9979 12 15C10.572 15 9.26 15.499 8.23 16.332L6.973 14.776V14.777ZM10.115 18.667C10.6481 18.2347 11.3137 17.9992 12 18C12.714 18 13.37 18.25 13.885 18.666L12 21L10.115 18.666V18.667Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgWifiLine, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/wifi-line.5ea6f3f2.svg";
export { ForwardRef as ReactComponent };